import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "section",
  id: "services"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "section-heading" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "title is-2" }, "Serviços"),
  /*#__PURE__*/_createElementVNode("h4", { class: "subtitle is-5" }, "Procura algum serviço?")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyServices = _resolveComponent("MyServices")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_MyServices)
  ]))
}